import React from 'react';
import EmailNotificationSettingsPage from '../settings/EmailNotificationSettingsPage';
import type { EmbeddedInConfigurationHub } from './models';

const EmailNotificationSettingsModule: React.FC<EmbeddedInConfigurationHub> = ({ embedded = true }) => (
  <EmailNotificationSettingsPage embedded={embedded} />
);

export default EmailNotificationSettingsModule;
